/*
 *
 * HomePage constants
 *
 */

export const SLICE_NAME = 'homepage';
